import { render, staticRenderFns } from "./FeedbackThread.vue?vue&type=template&id=047f7776&scoped=true"
import script from "./FeedbackThread.vue?vue&type=script&lang=js"
export * from "./FeedbackThread.vue?vue&type=script&lang=js"
import style0 from "./FeedbackThread.vue?vue&type=style&index=0&id=047f7776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f7776",
  null
  
)

export default component.exports